import "./FilterItem.scss";
interface FilterItemProps {
  id: string;
  name: string;
  icon: JSX.Element;
  checked: boolean;
  onChecked: () => void;
}
const FilterItem: React.FC<FilterItemProps> = ({
  id,
  name,
  icon,
  checked,
  onChecked,
}) => {
  return (
    <div
      className={`filter-item-container ${
        checked && "filter-item-container__item"
      }`}
    >
      <div
        onClick={() => onChecked()}
        className={`filter-item-container__checkbox ${
          checked && "filter-item-container__checkbox-checked"
        }`}
      >
        {checked && (
          <svg
            width="13"
            height="10"
            viewBox="0 0 13 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.88587 7.28023L11.4718 0.693604L12.4856 1.70671L4.88587 9.30644L0.326172 4.74674L1.33928 3.73364L4.88587 7.28023Z"
              fill="white"
            />
          </svg>
        )}
      </div>
      {icon}
      {name}
    </div>
  );
};
export default FilterItem;
